import React from 'react';
import ShowSnowStatus from 'src/components/findEntity/ShowSNOWStatus';
import { UserIcon } from '../commonComponents/UserIcon';
import WorkflowIntentionDisplay from '../commonComponents/WorkflowIntentionDisplay/WorkflowIntentionDisplay';
import { formatYesNo } from 'src/utils/StringUtils';

export const COLUMN_DEFINITIONS = [
	{
		id: 'entityType',
		header: 'Entity Type',
		cell: (item) => item.entityType,
		sortingField: 'entityType',
		minWidth: '100px',
	},
	{
		id: 'createdBy',
		header: 'Created By',
		cell: (item) => <UserIcon user={item.createdBy} />,
		sortingField: 'createdBy',
		minWidth: '100px',
	},
	{
		id: 'lastUpdatedBy',
		header: 'Last Updated By',
		cell: (item) => <UserIcon user={item.lastUpdatedBy} />,
		sortingField: 'lastUpdatedBy',
		minWidth: '100px',
	},
	{
		id: 'status',
		header: 'Status',
		cell: (item) => <ShowSnowStatus status={item.status} />,
		minWidth: '100px',
		sortingField: 'status',
	},
	{
		id: 'domains',
		header: 'Domains',
		cell: (item) => item.domains?.toString(),
		minWidth: '100px',
	},
	{
		id: 'workflowIntention',
		header: 'Workflow Intention',
		cell: (item) => (
			<WorkflowIntentionDisplay intention={item.workflowIntention} />
		),
		sortingField: 'workflowIntention',
	},
	{
		id: 'isReRunAllowed',
		header: 'Re-Run Allowed',
		cell: (item) => formatYesNo(item.isReRunAllowed),
		sortingField: 'isReRunAllowed',
	},
	{
		id: 'allowedDuringPeak',
		header: 'Allowed During Peak',
		cell: (item) => formatYesNo(item.allowedDuringPeak),
		sortingField: 'allowedDuringPeak',
	},
	{
		id: 'usableAsSubWorkflow',
		header: 'Can Be Used as Sub-workflow',
		cell: (item) => formatYesNo(Boolean(item.usableAsSubWorkflow)),
		sortingField: 'usableAsSubWorkflow',
	},
	{
		id: 'createdAt',
		header: 'Created At',
		cell: (item) =>
			item.createdAt
				? new Date(item.createdAt * 1000).toLocaleDateString('en-GB', {
						day: 'numeric',
						month: 'short',
						year: 'numeric',
				  })
				: '-',
		sortingField: 'createdAt',
	},
];

export const CONTENT_DISPLAY_OPTIONS = [
	{ id: 'workflowDefinitionName', label: 'Workflow Name', alwaysVisible: true },
	{ id: 'entityType', label: 'Entity Type' },
	{ id: 'status', label: 'Status' },
	{ id: 'createdBy', label: 'Created By' },
	{ id: 'lastUpdatedBy', label: 'Last Updated By' },
	{ id: 'domains', label: 'Domains' },
	{ id: 'workflowIntention', label: 'Workflow Intention' },
	{ id: 'isReRunAllowed', label: 'Re-Run Allowed' },
	{ id: 'allowedDuringPeak', label: 'Allowed During Peak' },
	{ id: 'usableAsSubWorkflow', label: 'Can Be Used as Sub-workflow' },
	{ id: 'createdAt', label: 'Created At' },
];

export const PAGE_SELECTOR_OPTIONS = [
	{ value: 10, label: '10 Workflows' },
	{ value: 30, label: '30 Workflows' },
	{ value: 50, label: '50 Workflows' },
];

export const COLLECTION_PREFERENCES = {
	title: 'Preferences',
	confirmLabel: 'Confirm',
	cancelLabel: 'Cancel',
	pageSizePreference: {
		title: 'Select page size',
		options: PAGE_SELECTOR_OPTIONS,
	},
	contentDisplayPreference: {
		title: 'Column preferences',
		options: CONTENT_DISPLAY_OPTIONS,
	},
	stripedRowsPreference: {
		label: 'Striped rows',
		description: 'Select to add alternating shaded rows',
	},
};

const DEFAULT_VISIBLE = [
	'workflowDefinitionName',
	'entityType',
	'status',
	'createdBy',
	'workflowIntention',
	'isReRunAllowed',
];

export const DEFAULT_PREFERENCES = {
	pageSize: 30,
	contentDisplay: CONTENT_DISPLAY_OPTIONS.map(({ id }) => ({
		id,
		visible: DEFAULT_VISIBLE.includes(id),
	})),
};

export const VIEW_FILTER = {
	ALL: 'all' as const,
	USER: 'user' as const,
} as const;

export type ViewFilterType = (typeof VIEW_FILTER)[keyof typeof VIEW_FILTER];
